import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import InAppMessage from "./in-app-message.js";

var HtmlMessage = /*#__PURE__*/function (_InAppMessage) {
  _inherits(HtmlMessage, _InAppMessage);

  var _super = _createSuper(HtmlMessage);

  function HtmlMessage(l, e, n, u, s, a, t, i, r, o, m) {
    var _this;

    _classCallCheck(this, HtmlMessage);

    u = u || InAppMessage.DismissType.MANUAL, null != l && l.length > 0 && l.indexOf('"ab-in-app-message ab-html-message ab-email-capture"') > 0 && l.indexOf('"ab-in-app-message ab-show ab-modal ab-effect-modal"') > 0 && (a = !0, t = !0), _this = _super.call(this, l, null, null, e, n, null, null, null, u, s, null, null, null, null, null, null, null, null, a, t, null, null, null, i, void 0, void 0, void 0, r, o), _this.messageFields = m;
    return _this;
  }

  _createClass(HtmlMessage, [{
    key: "ll",
    value: function ll() {
      return !1;
    }
  }, {
    key: "k",
    value: function k(l) {
      if (this.un === InAppMessage.es.el) {
        if (this.nl) return !1;
        this.nl = !0;
      }

      return this.lt.St(l), !0;
    }
  }]);

  return HtmlMessage;
}(InAppMessage);

export { HtmlMessage as default };
HtmlMessage.es = InAppMessage.es.el;